import ItemTypes from 'constants/ItemTypes';
import { useDragLayer } from 'react-dnd';
import CollapseDrag from './CollapseDrag';

const layerStyles = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 100,
  left: -20,
  top: -13,
  width: '100%',
};
function getItemStyles(initialOffset, currentOffset) {
  if (!initialOffset || !currentOffset) {
    return {
      display: 'none',
    };
  }

  const { x, y } = currentOffset;
  const transform = `translate(${x}px, ${y}px)`;
  return {
    opacity: 0.7,
    transform,
    WebkitTransform: transform,
  };
}

const DocumentBlockDragLayer = (style) => {
  const { itemType, isDragging, item, initialOffset, currentOffset } = useDragLayer((monitor) => {
    return {
      item: monitor.getItem(),
      itemType: monitor.getItemType(),
      initialOffset: monitor.getInitialSourceClientOffset(),
      currentOffset: monitor.getSourceClientOffset(),
      isDragging: monitor.isDragging(),
    };
  });
  function renderItem() {
    switch (itemType) {
      case ItemTypes.DOCUMENT_BLOCK:
        return <CollapseDrag label={item.data?.name} style={style} />;
      default:
        return null;
    }
  }
  if (!isDragging) {
    return null;
  }
  return (
    <div style={layerStyles}>
      <div style={getItemStyles(initialOffset, currentOffset)}>{renderItem()}</div>
    </div>
  );
};

export default DocumentBlockDragLayer;
